import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

/** Staff pages (leads, emails, QTE, negotiations...): a user with no role lands on access pending. */
export const staffGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (auth.canManageOrders()) return true;
  inject(NotificationService).warning('toast.warning', 'common.noPageAccess');
  return inject(Router).createUrlTree([auth.getLandingRoute()]);
};
